var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"container-center-header"},[_c('div',{staticClass:"line-header"},[_c('span',{staticClass:"group-box"},[_vm._v(_vm._s(_vm.$t("groups.title")))]),_c('span',{staticClass:"group_name"},[_vm._v(_vm._s(" " + _vm.group.name))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }